import { DepositAccount } from '../../domain/models/DepositAccount';
import './depostitAccountStyles.css';
import PropTypes from 'prop-types';
import { ImgPlaceholder } from '../ImgPlaceholder';

export const DepositAccountComponent = ({ account }: any) => {
    return (
        <>
            <div className="col-12 d-flex flex-row align-items-center">
                <div >

                    <ImgPlaceholder
                        style={{
                            width: '60px', height: '60px',
                        }}
                        placeholder={account.logo}
                        img={account.logo} />
                </div>
                <div className="ml-4 d-flex flex-column">
                    <b>{account.bank}</b>
                    {
                        account.id &&
                        <small>Banco: <b>{account.id}</b></small>
                    }
                    {
                        account.typeDeposit &&
                        <small>Tipo Pago: <b>{account.typeDeposit}</b></small>
                    }
                    {
                        account.store &&
                        <small>Sucursal: {account.store}</small>
                    }
                    {
                        account.name &&
                        <small>Nombre: {account.name}</small>
                    }
                    {
                        account.accountNumber &&
                        <small>No. cuenta: <b> {account.accountNumber}</b></small>
                    }
                    {
                        account.clabe &&
                        <small>Clabe: <b>{account.clabe}</b></small>
                    }
                    {
                        account.accountCard &&
                        <small>Cuenta tarjeta: <b>{account.accountCard}</b></small>
                    }
                </div>
            </div>
            <div className="divider" />
        </>
    )
}
DepositAccountComponent.props = {
    account: PropTypes.instanceOf(DepositAccount).isRequired
}
